import { Mutations } from '../mutations/session-mutations';
import { Getters } from '../getters/session-getters';

const initialState = {
  loggedIn: false,
  idToken: null,
  accessToken: null,
  username: null,
  websocketConnected: true,
};

export default {
  namespaced: true, // set to true in case we wish to use multiple modules at the same time
  state: initialState,
  mutations: Mutations,
  getters: Getters,
};
